import {DEFAULT_CURRENCY_CODE, enableProdMode, LOCALE_ID} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {DateParserFormatter} from "./_types/DateParserFormatter";
import {AppModule} from "./app/app.module";
import {environment} from "./environments/environment";
import {NgbDateParserFormatter} from "@ng-bootstrap/ng-bootstrap";

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
    providers: [
        {provide: LOCALE_ID, useValue: "pt-BR"},
        {provide: DEFAULT_CURRENCY_CODE, useValue: "BRL"}
    ]
})
    .catch(err => console.error(err));
